export const SessionTypeEnum = {
    session: "session",
    roundtable: "roundtable",
    speakersQA: "speakersQA",
    empty: ""
} as const;

export type SessionTypeEnum = typeof SessionTypeEnum[keyof typeof SessionTypeEnum];